import { createNavigation } from "next-intl/navigation";
import { routing } from "./routing";

/**
 * Locale-aware navigation primitives for the PUBLIC surface. Import { Link,
 * usePathname } from here instead of next/navigation so the `/<locale>/` prefix is
 * kept automatically (redirect/useRouter/getPathname are unused → not re-exported).
 * The unprefixed /app product surface keeps using next/navigation directly.
 */
export const { Link, usePathname } = createNavigation(routing);
